import type { SVGProps } from "react";

const SvgSchoellerbankSmallLogo = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="76.1 76.2 359.7 359.7"
    width="1em"
    height="1em"
    {...props}
  >
    <g fill="none" fillRule="evenodd">
      <path
        fill="#EC1C24"
        d="M148.158 400.036c-5.106 3.808-8.602 6.412-9.443 7.042-3.824 2.874-14.342 11.296-20.35 5.48-3.395-3.294-6.692-6.21-8.534-8.84 5.709.157 18.691-1.725 21.613-3.911.787-.59 3.9-2.91 8.484-6.33-39.022-32.995-63.8-82.313-63.8-137.414C76.128 156.719 156.657 76.19 256 76.19c66.014 0 123.722 35.56 155.012 88.572 5.22-5.801 8.484-10.553 9.479-14.391.59-2.29-.757-9.27-2.283-12.932 10.133 7.018 8.79 19.035 7.799 22.868-1.058 4.08-4.26 8.554-9.638 14.209 12.471 24.477 19.503 52.19 19.503 81.546 0 99.337-80.531 179.875-179.872 179.875-40.457 0-77.794-13.358-107.842-35.902"
      />
      <path
        fill="#FFF"
        d="M244.599 206.115s20.78-26.882 22.762-30.184c1.984-3.305 2.772-5.95-2.859-9.475-5.636-3.526-24.46-14.542-28.206-17.404-3.742-2.868-3.085-13.441 7.932-15.649 11.016-2.201 106.638-10.132 143.876-6.164 37.24 3.963 33.87 17.416 32.386 23.134-2.157 8.317-14.98 20.932-35.248 39.216 0 0-33.492 31.068-57.947 52.437-24.46 21.373-102.673 87.248-117.878 99.154-15.205 11.9-74.147 55.754-77.97 58.628-3.83 2.865-14.527 11.475-20.357 5.476-5.823-6.004 0-12.699 2.962-16.791 2.949-4.086 121.735-171.802 130.547-182.378"
      />
    </g>
  </svg>
);
export default SvgSchoellerbankSmallLogo;
